export const fromGraphql = str =>
  str.replace('GraphQL error:', '')

export const convertRole = role =>
  role === 'ADMIN'
    ? 'Admin'
    : role === 'SALES'
    ? 'Sales Rep'
    : role === 'CLIENT'
      ? 'Client'
      : 'WTF'

export const formatPhoneNumber = (number = '') => {
  if (!number) return ''
  const x = number.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
  // ex: x = ["9561231234", "956", "123", "1234", index: 0, input: "9561231234", groups: undefined]
  return !x[2] ? x[1] : `(${x[1]}) ${x[2]}${x[3] ? `-${x[3]}` : ``}`
}


// WEBPACK FOOTER //
// ./src/utils/strings.js